import { render, staticRenderFns } from "./CoozzyDatePicker.vue?vue&type=template&id=2fb6b47f&scoped=true"
import script from "./CoozzyDatePicker.vue?vue&type=script&lang=js"
export * from "./CoozzyDatePicker.vue?vue&type=script&lang=js"
import style0 from "./CoozzyDatePicker.vue?vue&type=style&index=0&id=2fb6b47f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6b47f",
  null
  
)

export default component.exports